import * as Sentry from '@sentry/tanstackstart-react';
import { useEffect } from 'react';

type DefaultErrorProps = {
  error: Error;
};

export function DefaultError({ error }: DefaultErrorProps) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <p className="text-2xl font-bold">
        Une erreur inattendue est survenue...
      </p>
      <pre className="text-sm">{error.message}</pre>
    </div>
  );
}
